import classes from "./MedicineForm.module.css";
import { Form, useNavigate, useNavigation, useActionData } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useRef, useState } from 'react';
import { FaPills, FaSave, FaTimes } from 'react-icons/fa';
import ConfirmModal from "../../UI/ConfirmModal";
import { useSubmit } from 'react-router-dom';

const MedicineForm = ({ method }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const data = useActionData();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';
  const submit = useSubmit();
  const formRef = useRef();

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  function cancelHandler() {
    navigate("..");
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setShowConfirmModal(true);
  };

  const confirmSubmitHandler = () => {
    setShowConfirmModal(false);
    if (formRef.current) {
      submit(formRef.current);
    }
  };

  const isEdit = method && method.toLowerCase() === 'put';

  return (
    <div className={classes.cardview}>
      <Form method='post' className={classes.form} onSubmit={handleSubmit} ref={formRef}>

        <div className={classes.sectionHeader}>
          <FaPills /> {t("Medicine Information")}
        </div>

        <div className="row">
          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="name">{t("Medicine Name")} <span className={classes.reqSign}>*</span></label>
            <input
              id="name"
              type="text"
              name="name"
              required
            />
          </div>
          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="medType">{t("Medicine Type")} <span className={classes.reqSign}>*</span></label>
            <select
              id="medType"
              name="medType"
              required
            >
              <option value="" hidden>{t("Select")}</option>
              <option value="TAB">TAB</option>
              <option value="CAP">CAP</option>
              <option value="SYR">SYR</option>
              <option value="SUSP">SUSP</option>
              <option value="SAC">SAC</option>
              <option value="INJ">INJ</option>
              <option value="DROP">DROP</option>
              <option value="EDRP">EDRP</option>
              <option value="LIQ">LIQ</option>
              <option value="OINT">OINT</option>
              <option value="CRE">CRE</option>
              <option value="GEL">GEL</option>
              <option value="LOT">LOT</option>
              <option value="POWDER">POWDER</option>
              <option value="SPRAY">SPRAY</option>
              <option value="SUPP">SUPP</option>
              <option value="ROTACAP">ROTACAP</option>
            </select>
          </div>
          <div className="col-md-4 col-6">
            <label className={classes.label} htmlFor="manufacturer">{t("Manufacturer")}</label>
            <input
              id="manufacturer"
              type="text"
              name="manufacturer"
            />
          </div>
          <div className="col-md-4 col-6 mt-2">
            <label className={classes.label} htmlFor="price">{t("Price")}</label>
            <input
              id="price"
              type="number"
              name="price"
            />
          </div>
          <div className="col-md-4 col-6 mt-2">
            <label className={classes.label} htmlFor="disease">{t("Disease")}</label>
            <input
              id="disease"
              type="text"
              name="disease"
            />
          </div>
          <div className="col-md-4 col-6 mt-2">
            <label className={classes.label} htmlFor="expiryDate">{t("Expiry Date")}</label>
            <input
              id="expiryDate"
              type="date"
              name="expiryDate"
            />
          </div>
          <div className="col-md-4 col-6 mt-2">
            <label className={classes.label} htmlFor="Barcode">{t("Barcode")}</label>
            <input
              id="barcode"
              type="number"
              name="barcode"
            />
          </div>
        </div>

        {data && data.errorMsg && (
          <div className="alert alert-danger mt-3 text-center">
            {t("Medicine Already Exist...")}
          </div>
        )}

        <div className={classes.actions}>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? <Spinner animation="border" size="sm" className="me-2" /> : <FaSave className="me-2" />}
            {isSubmitting ? t("Submitting...") : t('Save Details')}
          </button>
          <button
            type="button"
            onClick={cancelHandler}
            className={classes.secondaryBtn}
          >
            <FaTimes className="me-2" /> {t("Cancel")}
          </button>
        </div>
      </Form>
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={confirmSubmitHandler}
        title={isEdit ? t("Edit Medicine") : t("Add Medicine")}
        message={isEdit ? t("Are you sure you want to update this medicine?") : t("Are you sure you want to add this new medicine?")}
        variant="primary"
        confirmText={isEdit ? t("Update") : t("Confirm")}
      />
    </div>
  );
};
export default MedicineForm;
